import React from "react";
import { useMsal } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import Link from "@mui/material/Link";

function handleLogout(instance: IPublicClientApplication) {
  instance.logoutRedirect().catch((e) => {
    console.error(e);
  });
}

interface Props {
  children: React.ReactNode;
}

const SignOutButton: React.FC<Props> = ({ children }) => {
  const { instance } = useMsal();
  return (
    <Link underline="none" onClick={() => handleLogout(instance)}>
      {children}
    </Link>
  );
};

export default SignOutButton;
